import { DefaultTheme } from 'styled-components';

import { colors } from './colors';
import { Theme as MuiTheme } from './mui';

export const Theme: DefaultTheme = {
  ...MuiTheme,
  // MUI reads shadows[elevation] off this theme too (styled-engine-sc), so it must stay the 25-step array.
  shadows: Object.assign([...MuiTheme.shadows], colors.shadows) as DefaultTheme['shadows'],
  overlay: colors.overlay,
  tint: colors.tint,
  toast: colors.toast,
  ui: colors.ui,
  sidebar: colors.sidebar,
};
